import { render } from "./MemberReferralView.vue?vue&type=template&id=002d7452"
import script from "./MemberReferralView.vue?vue&type=script&lang=js"
export * from "./MemberReferralView.vue?vue&type=script&lang=js"

import "./MemberReferralView.vue?vue&type=style&index=0&id=002d7452&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__